module.exports = __webpack_public_path__ + "static/media/1 45 sendt.f8a06201.mp3";